import React from 'react'

const GroupLoan = () => {
    const emiSchedule = [
        { sno: 1, interest: 207.42, principal: 742.42, totalEmi: 950, balance: 9257.58 },
        { sno: 2, interest: 192.17, principal: 757.83, totalEmi: 950, balance: 8499.75 },
        { sno: 3, interest: 176.44, principal: 773.56, totalEmi: 950, balance: 7726.19 },
        { sno: 4, interest: 160.38, principal: 789.62, totalEmi: 950, balance: 6936.56 },
        { sno: 5, interest: 143.99, principal: 806.01, totalEmi: 950, balance: 6130.55 },
        { sno: 6, interest: 127.26, principal: 822.74, totalEmi: 950, balance: 5307.81 },
        { sno: 7, interest: 110.18, principal: 839.82, totalEmi: 950, balance: 4467.99 },
        { sno: 8, interest: 92.75, principal: 857.05, totalEmi: 950, balance: 3610.74 },
        { sno: 9, interest: 74.95, principal: 875.05, totalEmi: 950, balance: 2735.69 },
        { sno: 10, interest: 56.79, principal: 893.21, totalEmi: 950, balance: 1842.47 },
        { sno: 11, interest: 38.25, principal: 911.75, totalEmi: 950, balance: 930.72 },
        { sno: 12, interest: 19.32, principal: 930.68, totalEmi: 950, balance: 0 },
    ];
    return (
        <div className='max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20 flex flex-col gap-8'>
            <div>
                <h2 className="text-xl sm:text-2xl font-bold text-gray-900 mb-4">
                    What is Weekly Group Loan Amount?

                </h2>
                <p className="text-md text-gray-600 mx-auto leading-relaxed">
                    A weekly group loan is a type of loan typically offered to a group of individuals, often in microfinance settings. These loans are commonly used in rural or low-income areas to provide financial assistance for entrepreneurial or household needs. The unique aspect of a group loan is that all members of the group are collectively responsible for ensuring that each member repays their portion of the loan, creating a system of mutual accountability.
                </p>
            </div>

            <div>
                <h2 className="text-xl sm:text-2xl font-bold text-gray-900 mb-4">
                    Key Features of a Weekly Group Loan:
                </h2>
                <p className="text-md text-gray-600 mx-auto leading-relaxed">
                    <br />1. Group Responsibility: The loan is given to a group (often 5-10 individuals), and the group is jointly liable for repayment. If one member defaults, the entire group is affected.
                    <br />2. Weekly Repayment: Borrowers are required to make weekly repayments, which are often small and manageable, making it easier to repay over time.
                    <br />3. Loan Amount: The total loan amount is typically divided among group members, and it may vary depending on the size of the group, their income, and their financial needs.
                    <br />4. Low Interest Rates: Weekly group loans often come with relatively low interest rates, particularly in microfinance contexts, to make them more accessible to low-income borrowers.
                    <br />5. Financial Inclusion: These loans are often used to promote financial inclusion by giving underserved populations, like women or rural entrepreneurs, access to credit.
                    <br />6. Purpose of Loan: The loan can be used for various purposes, such as starting or expanding a small business, managing household expenses, paying for education, or covering medical costs.                </p>
            </div>

            <div>
                <h2 className="text-xl sm:text-2xl font-bold text-gray-900 mb-4 text-center">
                    GROUP LOAN <br /> GL WEEKLY LOAN AMOUNT = 10,000 Rs.
                </h2>
                <h2 className="text-xl sm:text-2xl font-bold text-blue-600 mb-4 text-center">
                    WEEKLY PAYMENT: 950 Rs. Total EMI - 12 WEEK
                </h2>

                <div className='border'>
                    <div className='flex  bg-blue-600'>
                        <div className='flex-1 p-4 '>
                            <p className='font-medium  text-md text-center text-white'>Sr No.</p>
                        </div>
                        <div className='flex-1 p-4 '>
                            <p className='font-medium text-md text-center text-white'>Interest</p>
                        </div>
                        <div className='flex-1 p-4'>
                            <p className='font-medium text-md text-center text-white'>Principal</p>
                        </div>
                        <div className='flex-1 p-4'>
                            <p className='font-medium text-md text-center text-white'>Total EMI</p>
                        </div>
                        <div className='flex-1 p-4'>
                            <p className='font-medium text-md text-center text-white'>Balance</p>
                        </div>
                    </div>
                    {
                        emiSchedule.map((item) => (
                            <div className='flex '>
                                <div className='flex-1 p-4 '>
                                    <p className='font-medium  text-md text-center'>{item.sno}</p>
                                </div>
                                <div className='flex-1 p-4 '>
                                    <p className='font-medium text-md text-center'>{item.interest}</p>
                                </div>
                                <div className='flex-1 p-4'>
                                    <p className='font-medium text-md text-center'>{item.principal}</p>
                                </div>
                                <div className='flex-1 p-4'>
                                    <p className='font-medium text-md text-center'>{item.totalEmi}</p>
                                </div>
                                <div className='flex-1 p-4'>
                                    <p className='font-medium text-md text-center'>{item.balance}</p>
                                </div>
                            </div>
                        ))
                    }
                </div>
            </div>

            <div>
                <h2 className="text-xl sm:text-2xl font-bold text-gray-900 mb-4">
                    Benefits:
                </h2>
                <p className="text-md text-gray-600 mx-auto leading-relaxed">
                    Mutual Support: Group lending fosters a sense of community, as group members help each other stay on track with their repayments.
                    <br />Flexible Repayment: Weekly installments are smaller, making it easier for borrowers to manage payments without major financial strain.
                    <br />Credit Building: Successfully repaying a group loan helps build creditworthiness, which can lead to larger loans or better financial opportunities in the future.                </p>
            </div>
        </div>
    )
}

export default GroupLoan
